export default "__VITE_ASSET__Dhhjoq24__"